import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { SessionDto } from '@repo/shared/dtos/devices/SessionDto';
import { myInsightsQueryKeys } from './queryKeys';
import { SESSIONS_BASE_URL, SESSIONS_PAGE_SIZE, EXPORT_BATCH_LIMIT } from '../config/constants';

interface SessionResponse {
  sessions: SessionDto[];
  totalPages: number;
}

async function fetchSessions(q: string, page: number, limit: number): Promise<SessionResponse> {
  const params = new URLSearchParams({ q, page: String(page), limit: String(limit) });
  const response = await fetch(`${SESSIONS_BASE_URL}?${params}`);
  if (!response.ok) throw new Error('Failed to fetch sessions');
  return response.json();
}

export const useInsightsSessions = ({
  searchQuery = '',
  page = 1,
  limit = SESSIONS_PAGE_SIZE,
}: {
  searchQuery?: string;
  page?: number;
  limit?: number;
} = {}) =>
  useQuery({
    queryKey: myInsightsQueryKeys.sessions.list(page, limit, searchQuery),
    queryFn: () => fetchSessions(searchQuery, page, limit),
    placeholderData: keepPreviousData,
  });

export const useAllInsightsSessions = ({ enabled = false }: { enabled?: boolean } = {}) =>
  useQuery({
    queryKey: myInsightsQueryKeys.sessions.all(''),
    queryFn: async () => {
      const data = await fetchSessions('', 1, EXPORT_BATCH_LIMIT);
      return data.sessions;
    },
    enabled,
    staleTime: 5 * 60 * 1000,
  });
